import SpotUtils from 'utils/spot';

export default function getFilteredSearchResults({
    filters,
    spots,
    isMonthly,
    airport,
    sortBy,
}) {
    let filteredSpots;

    /* V2-CLEANUP
    Remove the else branch when Search V2 Integration is complete
    Remove the isV2 flag from spot data when Search V2 Integration is complete
    This is used on Search for Transient, Monthly, Airport, and Event verticals */
    // there is no easy way to pass a V2 flag down, so get it from the spots
    if (spots[0]?.isV2) {
        const visibleSpots = filters
            ? SpotUtils.sortByAttributeV2(
                  SpotUtils.filterV2(spots, filters, isMonthly),
                  sortBy
              )
            : spots;

        filteredSpots = visibleSpots.map(
            ({spotId, title, selectedRate, tag}) => ({
                spotId,
                title,
                price: selectedRate?.totalPrice?.value,
                ...(airport && {tag}),
            })
        );
    } else {
        const visibleSpots = filters
            ? SpotUtils.sortByAttribute(
                  SpotUtils.filter(spots, filters, isMonthly),
                  sortBy
              )
            : spots;

        filteredSpots = visibleSpots.map(
            ({spotId, title, selectedRate, facility: {tag}}) => ({
                spotId,
                title,
                price: selectedRate?.price,
                ...(airport && {tag}),
            })
        );
    }

    return filteredSpots;
}
